import React, { Component } from "react";
import _ from "lodash";
import { withRouter } from "../../../withRouter";
import FetchServerData from "../../../provider/FetchServerData";
import { Card, CardBody } from "reactstrap";
import { InputAdornment } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@material-ui/core/TextField";
import { MenuWithBreadScrum } from "../../menu/MenuWithBreadScrum";
import store from "../../../redux/store";
import PrintRoundedIcon from "@material-ui/icons/PrintRounded";
import ReactToPrint from "react-to-print";
import Button from "@material-ui/core/Button";
import BackIconButton from "../../buttons/BackIconButton";
import Pagination from "../../assetTracking/Pagination";

class ActiveAssetList extends Component {
  header = store.getState().header.header;
  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
    let pageId = "";
    let assetBreadCrumb = [
      { pageid: "/reports", uiname: "MIS Reports" },
      { pageid: "/assetAnalytics", uiname: "Asset Analytics" },
      { pageid: "", uiname: "Active Asset List" },
    ];
    let activeAssetBreadCrumb = [
      { pageid: "/reports", uiname: "MIS Reports" },
      { pageid: "/organizationAssets", uiname: "organization Asset Analytics" },
      { pageid: "", uiname: "Active Asset List" },
    ];
    if (props.state) {
      pageId = props.state.pageId;
    }
    if (pageId === "activeAsset") {
      this.breadCrumb = activeAssetBreadCrumb;
    } else {
      this.breadCrumb = assetBreadCrumb;
    }
    this.state = {
      pageId: pageId,
      searchText: "",
      pageNo: 0,
      pageSize: 10,
      totalRecords: 0,
      activeAssetList: [],
      isPaging: false,
      render: false,
      showPerPage: 10,
      totalPages: 0,
    };
    this.debouncedSearch = _.debounce(this.getActiveAssetList, 800);
  }

  componentDidMount() {
    this.getActiveAssetList(this.state.pageNo, this.state.pageSize);
  }
  getActiveAssetList(pageNo, pageSize) {
    const postObject = {
      header: this.header,
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo,
        pageSize: pageSize,
      },
    };

    FetchServerData.callPostService("/misms/activeAssetList", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let activeAssetList = output.data.assetList;
          console.log("activeAssetList", activeAssetList);
          let page = output.data.page;
          let isPaging = false;
          if (activeAssetList.length > this.state.pageSize) {
            isPaging = true;
          }
          this.setState({
            render: true,
            isPaging: isPaging,
            activeAssetList: activeAssetList,
            pageNo: page?.pageNo,
            showPerPage: page?.pageSize,
            totalPages: page?.totalPages,
            totalRecords: page?.total,
          });
        } else {
          console.error("API Error:", output);
          this.setState({ render: true, activeAssetList: [] });
        }
      })
      .catch((error) => {
        console.error("Failed to fetch active assets:", error);
        this.setState({ render: true, activeAssetList: [] });
      });
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ pageNo: page, pageSize: pageSize });
  }

  backButton() {
    if (this.state.pageId === "activeAsset") {
      this.props.navigate("/organizationAssets");
    } else {
      this.props.navigate("/assetAnalytics");
    }
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.setState({
      pageNo: currentPageIndex,
      showPerPage: pageSize,
    });
    this.getActiveAssetList(currentPageIndex, pageSize);
    this.debouncedSearch = _.debounce(this.getActiveAssetList, 800);
  }

  onSearchChange(e) {
    const val = e.target.value;
    this.setState({ searchText: val }, () => {
      this.debouncedSearch(this.state.pageNo, this.state.pageSize);
    });
  }

  render() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <MenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            navigate={this.props.navigate}
            domainObject="Active Asset"
          // name="Active Asset List"
          />
          {this.state.activeAssetList.length > 0 ||
            this.state.searchText !== "" ? (
            <>
              <div className="row pe-2">
                <div className="col-md-6 text-start p-2">
                  <BackIconButton onClick={this.backButton.bind(this)} />
                </div>
                <div className="col-md-6 text-end p-2">
                  <ReactToPrint
                    trigger={() => (
                      <Button
                        variant="contained"
                        size="small"
                        id="printBtn"
                        style={{
                          background: "#0577ab",
                          color: "#fff",
                          padding: "5px",
                          width: "100px",
                        }}
                        startIcon={<PrintRoundedIcon />}
                      >
                        print
                      </Button>
                    )}
                    content={() => this.componentRef.current}
                  />
                </div>
              </div>
              <div className="row" ref={this.componentRef}>
                <div className="col-md-12">
                  <div className="card">
                    <div className="row justify-content-between p-3">
                      <div className="d-flex col-12 col-lg-4 col-xl-4">
                        <div className="col-12 text-start totalResults">
                          <span>Active Assets: {this.state.totalRecords}</span>
                        </div>
                      </div>
                      <div className="d-flex col-12 col-lg-8 col-xl-8">
                        <div className="col-12 text-end">
                          <TextField
                            id="standard-search"
                            placeholder="Search"
                            type="search"
                            variant="standard"
                            value={this.state.searchText}
                            onChange={this.onSearchChange.bind(this)}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={this.getActiveAssetList.bind(
                                      this,
                                      this.state.pageNo,
                                      this.state.showPerPage
                                    )}
                                  >
                                    <SearchIcon />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive paginationTable">
                      <table className="table text-start table-hover">
                        <thead className="paginationTableThead">
                          <tr>
                            <th scope="col fw-bold">#</th>
                            <th scope="col fw-bold">Asset Name</th>
                            <th scope="col fw-bold">Asset UID</th>
                            <th scope="col fw-bold">Asset Code</th>
                            <th scope="col fw-bold">Asset Type</th>
                            <th scope="col fw-bold">Description</th>
                            <th scope="col fw-bold">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.activeAssetList?.map((rowData, index) => (
                            <tr
                              key={index}
                              style={{
                                backgroundColor:
                                  rowData.id === this.state.assetId
                                    ? "#e6effc"
                                    : "#fff",
                                cursor: "pointer",
                              }}
                            >
                              <td>
                                {this.state.pageNo * this.state.showPerPage +
                                  index +
                                  1}
                              </td>
                              <td
                                style={{ width: "20%" }}
                                onClick={(e) => this.viewAsset(e, rowData)}
                              >
                                {rowData.name}
                              </td>
                              <td
                                style={{ width: "15%" }}
                                onClick={(e) => this.viewAsset(e, rowData)}
                              >
                                {rowData.uid}
                              </td>
                              <td
                                style={{ width: "15%" }}
                                onClick={(e) => this.viewAsset(e, rowData)}
                              >
                                {rowData.assetcode}
                              </td>
                              <td
                                style={{ width: "15%" }}
                                onClick={(e) => this.viewAsset(e, rowData)}
                              >
                                {rowData.assetType}
                              </td>
                              <td
                                style={{ width: "20%" }}
                                onClick={(e) => this.viewAsset(e, rowData)}
                              >
                                {rowData.description}
                              </td>
                              <td
                                style={{ width: "10%" }}
                                onClick={(e) => this.viewAsset(e, rowData)}
                              >
                                {rowData.status}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {this.state.totalRecords === 0 && (
                      <div className="row text-center p-2">
                        <h5>Data not Available</h5>
                      </div>
                    )}
                    {this.state.totalRecords > 10 && (
                      <div className="row justify-content-between pagination p-2">
                        <div className="pageSize col-4 text-start">
                          Page {this.state.pageNo + 1} of{" "}
                          {this.state.totalPages}
                        </div>
                        <div className="col-4 text-end">
                          <Pagination
                            showPerPage={this.state.showPerPage}
                            onPaginationChange={this.onPaginationChange.bind(
                              this
                            )}
                            total={this.state.totalRecords}
                            pageNo={this.state.pageNo}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="row">
              <div className="row pe-2">
                <div className="col-md-12 text-start p-2">
                  <BackIconButton onClick={this.backButton.bind(this)} />
                </div>
              </div>
              <div className="col-md-12">
                <Card>
                  <CardBody>
                    <div className="row">
                      <div className="col-md-12" style={{ padding: "2em" }}>
                        <h5>
                          <b>Active Assets Not Found</b>
                        </h5>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </div>
            </div>
          )}
        </>
      );
    }
  }
}
export default withRouter(ActiveAssetList);
